import { render, staticRenderFns } from "./LanguageBubble.vue?vue&type=template&id=facf86de&scoped=true"
import script from "./LanguageBubble.vue?vue&type=script&lang=js"
export * from "./LanguageBubble.vue?vue&type=script&lang=js"
import style0 from "./LanguageBubble.vue?vue&type=style&index=0&id=facf86de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "facf86de",
  null
  
)

export default component.exports